import { alpha } from "@mui/material/styles";
import type {
	CalendarEvent,
	CalendarEventType,
} from "@/shared/repositories/CalendarEventRepository";

export interface EventTypeConfig {
	code: CalendarEventType;
	name: string;
	bg: string;
	color: string;
}

export const EVENT_TYPES: EventTypeConfig[] = [
	{ code: "W", name: "Work Order", bg: "#E3F2FD", color: "#1565C0" },
	{ code: "M", name: "Maintenance", bg: "#F3E5F5", color: "#7B1FA2" },
	{ code: "D", name: "Downtime", bg: "#ECEFF1", color: "#455A64" },
	{ code: "H", name: "Holiday", bg: "#FFF8E1", color: "#F9A825" },
	{ code: "B", name: "Break / Lunch", bg: "#E0F2F1", color: "#00695C" },
];

export const getEventType = (code: string): EventTypeConfig =>
	EVENT_TYPES.find((t) => t.code === code) ?? EVENT_TYPES[0];

type EventLike = Pick<
	CalendarEvent,
	"EventTypeCode" | "BreakLabel" | "IsSpell"
>;

export const isSpellBreak = (event: EventLike) =>
	event.EventTypeCode === "B" && event.IsSpell;

export const eventDisplayName = (event: EventLike) => {
	const base =
		event.EventTypeCode === "B" && event.BreakLabel
			? event.BreakLabel
			: getEventType(event.EventTypeCode).name;
	return isSpellBreak(event) ? `${base} · Spell` : base;
};

// Spell breaks render striped: scheduled, but the line keeps running
export const stripedFill = (color: string, gap = 6, width = 4) => ({
	backgroundImage: `repeating-linear-gradient(135deg, transparent 0 ${gap}px, ${alpha(color, 0.18)} ${gap}px ${gap + width}px)`,
});
